<template>
  <blockquote class="quote-block">
    <p>“{{ quote }}”</p>
    <cite v-if="attribution">{{ attribution }}</cite>
  </blockquote>
</template>

<script>
export default {
  name: 'QuoteBlock',
  props: {
    quote: { type: String, required: true },
    attribution: { type: String, default: '' },
  },
};
</script>

<style scoped>
.quote-block {
  max-width: 680px;
  margin: 32px auto;
  text-align: center;
  background: #fff;
  border: 1px solid #e6ebf1;
  border-radius: 12px;
  padding: 24px 28px;
  box-shadow: 0 8px 24px rgba(0, 36, 88, 0.06);
}

.quote-block p {
  font-size: 20px;
  color: var(--brand-navy, #002458);
  font-weight: 600;
  margin: 0 0 10px;
  line-height: 1.4;
}

.quote-block cite {
  font-style: normal;
  color: var(--brand-grey, #6b7280);
  font-weight: 600;
  font-size: 14px;
}
</style>
